import { render, staticRenderFns } from "./MemoInboxModal.vue?vue&type=template&id=9d8ab736&"
import script from "./MemoInboxModal.vue?vue&type=script&lang=js&"
export * from "./MemoInboxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports